import { z } from 'zod'
import { Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

/** 管理者資訊 Schema */
export const managerInfoSchema = z.object({
  /** 身份 */
  identity: enumWithEmpty(Identity),
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 英文姓名 */
  englishName: z.string(),
  /** 姓名 */
  name: z.string(),
  /** 部門 */
  department: z.string()
})

/** 管理者資訊 */
export interface ManagerInfo extends z.infer<typeof managerInfoSchema> {}
